import {
  enumElementBorderStyle,
  enumFillMode,
  enumHorzCentering,
  enumIconIndex,
  enumImageIndex,
  enumVertCentering,
  enumXMLType,
  kRoundRectRadius,
  kSmallIcon
} from "../constants";
import { QBoxOverlay } from "./QBoxOverlay";
import { SVG_DrawImage } from "../utils/SVG_DrawImage";
import { XML_Scale } from "../utils/XML_Scale";
import { XML_ScaleAndShiftX } from "../utils/XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "../utils/XML_ScaleAndShiftY";
import { XML_GetScale } from "../utils/XML_GetScale";
import { RoundTo3 } from "../utils/RoundTo3";
import { XML_DrawPlanIconPDF } from "../utils/XML_DrawPlanIconPDF";
import { doDrawIcon } from "../utils/doDrawIcon";
import { SVG_RenderChartBox } from "../utils/SVG_RenderChartBox";
import { XML_RenderChartBoxPDF } from "../utils/XML_RenderChartBoxPDF";
import { XML_Cmd4 } from "../utils/XML_Cmd4";
import { XML_Param4 } from "../utils/XML_Param4";

export class QBoxOverlay_Filter extends QBoxOverlay {
  constructor() {
    super();
    this.fDeltaDefX = -6;
    this.fDeltaDefY = -4;
    this.fVPosition = enumVertCentering.pinBottom;
    this.fHPosition = enumHorzCentering.pinRight;
    this.fShowFilterIcon = true; // mute
    this.fFilterFill = "#282727";
  }

  Init(wsMgr, showIcon) {
    var imageMgr = wsMgr.fImageMgr;
    var enabledImageIdx = enumImageIndex.appIcons;
    var xSpacing = 96,
      ySpacing = 96;
    var xSize = 24,
      ySize = 24;
    var imageRef = enumIconIndex.filter;
    var yOffset = Math.floor(imageRef / 12);
    var xOffset = imageRef % 12;

    var enabledImage = imageMgr.GetSubImage(
      enabledImageIdx,
      xOffset,
      yOffset,
      xSize,
      ySize,
      xSpacing,
      ySpacing
    );
    this.fEnabledImage = enabledImage;
    this.fShowFilterIcon = showIcon;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var iconImage = this.fEnabledImage;
    var chartBox = this.fChartBox;

    ctx.save();
    chartBox.SetChartBoxClip(drawBuffer);

    ctx.fillStyle = "#282727";
    ctx.lineJoin = "miter";
    ctx.lineCap = "square";
    ctx.lineWidth = 3;

    var width = this.fOverrideWidth !== null ? this.fOverrideWidth : chartBox.GetWidth();
    var height = chartBox.GetHeight();
    var x = this.GetPositionX() - this.fDeltaDefX;
    var y = this.GetPositionY() - this.fDeltaDefY;

    ctx.globalAlpha = 0.6;
    ctx.fillRect(x, y, -width, -height);

    ctx.restore();
    if (this.fShowFilterIcon === true)
      doDrawIcon(
        ctx,
        iconImage,
        0,
        0,
        iconImage.width,
        iconImage.height,
        this.fHorzOffset + this.fDeltaDefX,
        this.fVertOffset,
        24,
        24,
        true
      );
  }

  DoAltRender(altCanvas) {
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    var x = this.GetPositionX();
    var y = this.GetPositionY();
    var width = this.fChartBox.GetWidth();
    if (this.fOverrideWidth !== null) {
      width = this.fOverrideWidth;
    }
    var layer = this.GetLayer();
    var scale = XML_GetScale(altCanvasElement, layer); // drawElement["scale"];
    if (scale != null) width *= scale;

    var chartBox = this.fChartBox;
    var r = chartBox.GetAdjBounds(kRoundRectRadius);
    var r1 = chartBox.GetOuterBorder(r, kRoundRectRadius);
    switch (altCanvasType) {
      case "SVG":
        if (chartBox.GetDataObj())
          SVG_RenderChartBox(
            r,
            r1,
            chartBox.GetBoxShapeType(),
            enumFillMode.opacityfill,
            this.fFilterFill,
            false,
            false,
            false,
            false,
            false,
            altCanvasElement,
            false
          );
        SVG_DrawImage(
          this.fHorzOffset + this.fDeltaDefX,
          this.fVertOffset + this.fDeltaDefY,
          24,
          24,
          null,
          null,
          null,
          this.fEnabledImage,
          layer,
          altCanvasElement
        );
        break;
      case "XML":
        var docType = altCanvasElement.GetDocType();

        var lineLen = Math.floor(width / 14) * 2;
        var scale = XML_GetScale(altCanvasElement, layer); // drawElement["scale"];
        if (scale != null) lineLen *= scale;
        var x0 = null;
        var y0 = null;
        if (docType === enumXMLType.PDF) {
          x0 = XML_ScaleAndShiftX(x - lineLen / 5, altCanvasElement, layer);
          y0 = XML_ScaleAndShiftY(y - lineLen / 8, altCanvasElement, layer);
          y0 = altCanvasElement.ConvertY(y0);
          if (chartBox.GetDataObj())
            XML_RenderChartBoxPDF(
              r,
              r1,
              chartBox.GetBoxShapeType(),
              enumFillMode.solidFill,
              this.fFilterFill,
              enumElementBorderStyle.noBorder,
              0,
              false,
              false,
              false,
              altCanvasElement,
              layer,
              false,
              0.5
            );
          var scaledIconSize = Math.round(
            XML_Scale(kSmallIcon.imageWidth, altCanvasElement, layer)
          );
          XML_DrawPlanIconPDF(
            x0,
            y0,
            scaledIconSize,
            scaledIconSize,
            lineLen,
            this.fFilterFill,
            this.fFilterFill,
            "filter",
            layer,
            altCanvasElement
          );
        } else {
          if (!chartBox.GetDataObj()) {
            x += 4;
            y += 4;
          }
          x0 = XML_ScaleAndShiftX(x - lineLen / 5, altCanvasElement, layer);
          y0 = XML_ScaleAndShiftY(y, altCanvasElement, layer);
          y0 = altCanvasElement.ConvertY(y0);
          //var r = chartBox.GetAdjBounds(kRoundRectRadius);
          if (chartBox.GetDataObj()) {
            //XML_ShiftRect(r, altCanvasElement, layer);

            //r.fTop = altCanvasElement.ConvertY(r.fTop);
            //r.fBottom = altCanvasElement.ConvertY(r.fBottom);

            //XML_Cmd4(XML_GetChartBoxShapeString(chartBox.GetBoxShapeType()), RoundTo3(r.fLeft), RoundTo3(r.fTop), RoundTo3(r.fRight-r.fLeft), RoundTo3(r.fBottom - r.fTop),altCanvasElement);
            //XML_Param4("p", this.fFilterFill, this.fFilterFill, 1, 0, altCanvasElement);

            XML_Cmd4(
              "filter",
              RoundTo3(x0),
              RoundTo3(y0),
              RoundTo3(lineLen),
              RoundTo3(-lineLen),
              altCanvasElement
            );
            XML_Param4("p", this.fFilterFill, this.fFilterFill, 1, 0, altCanvasElement);
          }
        }
        break;
    }
  }
}
